import type { FC } from "react";
import React, { useEffect } from "react";
import { useBrand, useLocale, type Brands } from "@edreamsodigeo/frontend-core";

import type { TrustPilotWidgetProps } from "./contract";
import { TrustPilotTheme } from "./contract";
import { useTrustpilot } from "~/clientState/providers/TrustpilotProvider";
import {
  TRUSTPILOT_COMPONENT_ID,
  getTrustPilotWidgetConfig,
} from "./constants";

const TrustPilotWidget: FC<TrustPilotWidgetProps> = ({
  trustPilotType,
  trustPilotTheme = TrustPilotTheme.LIGHT,
  height,
}) => {
  const brand: Brands = useBrand();
  const locale: string = useLocale();
  const { scriptLoaded, loadTrustpilot } = useTrustpilot();
  const config = getTrustPilotWidgetConfig(brand, locale, trustPilotType);

  useEffect(() => {
    if (scriptLoaded) {
      loadTrustpilot(TRUSTPILOT_COMPONENT_ID);
    }
  }, [scriptLoaded, loadTrustpilot]);

  if (brand === "TR") {
    return null;
  }

  return (
    <div>
      {scriptLoaded && (
        <div
          id={TRUSTPILOT_COMPONENT_ID}
          data-testid={TRUSTPILOT_COMPONENT_ID}
          className={"trustpilot-widget"}
          data-locale={locale}
          data-template-id={config.dataTemplateId}
          data-businessunit-id={config.dataBusinessUnitId}
          data-style-height={height || config.dataTemplateHeight}
          data-style-width={"100%"}
          data-theme={trustPilotTheme}
          data-font-family={"Rubik"}
        >
          <a href={config.url} target={"_blank"} rel={"noopener noreferrer"}>
            Trustpilot
          </a>
        </div>
      )}
    </div>
  );
};

export default TrustPilotWidget;
